import SectionLabel from "../../../components/SectionLabel";
import SystemSpecs from "../../../components/private/SystemSpecs";

export default function SpecsSection({ specs }) {
    return (
        <section className="section-pad bg-[#15161A] border-y border-[rgba(201,168,106,0.12)] overflow-hidden">
            <div className="shell">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 mb-10 md:mb-14">
                    <div className="lg:col-span-7">
                        <SectionLabel
                            number="02"
                            label="System Specifications"
                        />
                        <h2 className="mt-8 font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.1]">
                            The disciplines,{" "}
                            <span className="italic text-[#C9A86A]">
                                enumerated.
                            </span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-[#9A958A] text-[15px] leading-[1.85] lg:pt-12">
                        Specification snapshot across the seven trades
                        composing this residence. Details are indicative;
                        the actual delivered document runs to several
                        hundred pages and is not available without an
                        additional project-specific NDA.
                    </p>
                </div>
                <SystemSpecs specs={specs} />
            </div>
        </section>
    );
}
